// test236
(236 && 0);
